import React from 'react';

import withAuthServerSideProps from '@/libs/auth';
import ProductDetailLayout, { ProductDetailLayoutProps } from '@/features/products/detail';

import { toInt } from '@/libs/app';
import { KeyActive, PageLayout, PagePath } from '@/layouts/shared';
import { getAuthServer } from '@/libs/cookies';
import { GetServerSidePropsContext } from 'next';
import { fetchProduct, fetchProductAuth } from '@/features/products/detail/api';
import { getSelectorsByUserAgent } from 'react-device-detect';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const ProductDetailPage = ({ handle, catCode, product, isAuth, isMobile }: ProductDetailLayoutProps) => {
  return (
    <ProductDetailLayout product={product} isAuth={isAuth} catCode={catCode} isMobile={isMobile} handle={handle} />
  );
};

export const getServerSideProps = withAuthServerSideProps(
  async (context: GetServerSidePropsContext) => {
    try {
      const { locale, query, req } = context;

      const { id, slug } = query;
      const handle = slug || '';
      let _id = slug;
      const arrHandle = (slug as string).split('-');
      if ((arrHandle?.length as any) > 1) {
        _id = (arrHandle as any)[(arrHandle?.length as any) - 2];
      }
      const { isAuth, token } = getAuthServer(context);
      const { data: product } = isAuth
        ? await fetchProductAuth(toInt(_id), token || '')
        : await fetchProduct(toInt(_id));

      const { isMobile } = getSelectorsByUserAgent(req.headers['user-agent'] as string);
      return {
        props: {
          isAuth,
          product,
          handle,
          isMobile,
          catCode: id,
          layout: PageLayout.New,
          keyActive: KeyActive.ProductDetail,
          isShowNav: false,
          ...(await serverSideTranslations(locale as string, ['product', 'layout'])),
        },
      };
    } catch (error: any) {
      if (error.code === 'HIDE_PRODUCT')
        return {
          redirect: {
            permanent: false,
            destination: PagePath.ProductHide,
          },
        };
      return {
        redirect: {
          permanent: false,
          destination: PagePath.DashboardPage,
        },
      };
    }
  },
  { isAntiAuth: false, isPublic: true }
);

export default ProductDetailPage;
